import Countdown from "../../components/public/Countdown";

export default function Home() {
    return (
        <main>
            <Countdown />
        </main>
    );
}
